import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { homepageIndustries } from '../../pages/industriesData';
import './Industries.css';

export const Industries = () => {
  const reduced = useReducedMotion();

  const fade = (i = 0) => ({
    initial: { opacity: 0, y: reduced ? 0 : 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: '-60px' },
    transition: { duration: reduced ? 0.2 : 0.55, delay: reduced ? 0 : i * 0.06, ease: [0.16, 1, 0.3, 1] },
  });

  return (
    <section className="industries-section">
      <div className="industries-container">
        <motion.div className="industries-head" {...fade(0)}>
          <h2 className="industries-title">Built for your industry</h2>
          <p className="industries-sub">
            We've shipped agents across 10+ verticals. Here are the most common.
          </p>
        </motion.div>

        <div className="ind-grid">
          {homepageIndustries.map((ind, i) => {
            const Icon = ind.icon;
            return (
              <motion.div key={ind.id} {...fade(i + 1)}>
                <Link to={`/use-cases#${ind.id}`} className="ind-card">
                  <div className="ind-card-top">
                    <div className="ind-card-icon">
                      <Icon size={20} />
                    </div>
                    <h3 className="ind-card-name">{ind.label}</h3>
                  </div>
                  <ul className="ind-card-agents">
                    {ind.agents.slice(0, 3).map((a) => (
                      <li key={a.name}>{a.name}</li>
                    ))}
                  </ul>
                  <span className="ind-card-more">
                    See use cases <ArrowRight size={13} />
                  </span>
                </Link>
              </motion.div>
            );
          })}
        </div>

        <motion.div className="industries-more" {...fade(8)}>
          <Link to="/use-cases" className="industries-more-link">
            See all 10 industries <ArrowRight size={15} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
